module.exports = __webpack_public_path__ + "static/media/origami14.1ff650b4.JPG";